export default __webpack_public_path__ + "static/media/64fc9d1e525bd33fa38178cead5e2f71.png";